import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const dur = 1300;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setCount(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else {
        setTimeout(() => { setGone(true); onDone(); }, 250);
        setTimeout(() => setGone(true), 400);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          className="fixed inset-0 z-[300] bg-obsidian flex flex-col items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          data-testid="preloader"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-gold mb-4">
            Tomazo Productions
          </p>
          <p className="font-display text-7xl sm:text-8xl font-extrabold text-outline">
            {count}
          </p>
          <div className="w-48 h-px bg-white/10 mt-8 overflow-hidden">
            <div className="h-full bg-gold transition-all duration-100" style={{ width: `${count}%` }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
